import { Button, IconButton, styled } from '@mui/material';
import FormField from 'further-ui/components/FormField';
import { Row } from 'further-ui/components/Layout';
import { ApplicationDetail } from '../types';
import NumberInput from 'further-ui/components/NumberInput';
import { CurrencyCode } from 'further-types/lp/vehicle';
import useVehicleApplication from 'hooks/lp/data/vehicleApplication/useVehicleApplication';
import CurrencySelector from 'further-ui/components/CurrencySelector';
import { useState } from 'react';
import Close from '@mui/icons-material/Close';

const CloseButton = styled(IconButton)({
  padding: 0,
});

const labels = {
  [ApplicationDetail.TargetCommitment]: 'Target commitment',
  [ApplicationDetail.LocalCurrency]: 'Investor local currency',
};

type Props = {
  vehicleApplicationId: string;
  vehicleId: string;
  detail: ApplicationDetail;
  onClose: () => void;
  baseCurrency?: CurrencyCode;
};

const ApplicationDetailForm: React.FC<Props> = ({
  vehicleApplicationId,
  vehicleId,
  detail,
  onClose,
  baseCurrency,
}) => {
  const { vehicleApplication, saveApplicationDetails, isPending } =
    useVehicleApplication(vehicleId, vehicleApplicationId);

  const [localCurrencyValue, setLocalCurrencyValue] = useState<
    CurrencyCode | undefined
  >(vehicleApplication.investorLocalCurrency);
  const [targetCommitmentValue, setTargetCommitmentValue] = useState<
    number | null
  >(vehicleApplication.targetCommitment);

  const handleSave = () => {
    if (isPending) {
      return;
    }

    saveApplicationDetails(
      {
        vehicleApplicationId,
        vehicleId,
        targetCommitment:
          detail === ApplicationDetail.TargetCommitment
            ? targetCommitmentValue ?? 0
            : vehicleApplication.targetCommitment,
        investorLocalCurrency:
          detail === ApplicationDetail.LocalCurrency
            ? localCurrencyValue
            : vehicleApplication.investorLocalCurrency,
      },
      {
        onSuccess: onClose,
      },
    );
  };

  return (
    <FormField label={labels[detail]} size="md">
      <Row spacing="sm" centered fullWidth>
        {detail === ApplicationDetail.TargetCommitment && (
          <NumberInput
            fullWidth
            currency={baseCurrency}
            onChange={setTargetCommitmentValue}
            value={targetCommitmentValue}
            size="small"
            decimals={2}
            hideZeroValue
          />
        )}
        {detail === ApplicationDetail.LocalCurrency && (
          <>
            <CurrencySelector
              fullWidth
              placeholder="Select currency"
              value={localCurrencyValue}
              onChange={(currency: CurrencyCode) => {
                setLocalCurrencyValue(currency);
              }}
            />
          </>
        )}
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          disabled={isPending}
        >
          Save
        </Button>
        <CloseButton size="small" onClick={onClose} disabled={isPending}>
          <Close fontSize="small" />
        </CloseButton>
      </Row>
    </FormField>
  );
};

export default ApplicationDetailForm;
